import { render, staticRenderFns } from "./LaboratoryContactCard.vue?vue&type=template&id=2d354d85"
import script from "./LaboratoryContactCard.vue?vue&type=script&lang=js"
export * from "./LaboratoryContactCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports